module.exports = __webpack_public_path__ + "img/star.959da6b3.svg";